// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3L4NO","right":"styles_right__3GfMr"};